import { ButtonSimple } from '@jollywise/jollygoodgame';

export class ButtonClimateChampions extends ButtonSimple {
  constructor(scene, opts) {
    // opts.resizeHitareaOnly = true;
    if (!opts.hasOwnProperty('clickSFX')) {
      opts.clickSFX = { sprite: 'general', id: 'general_button' };
    }
    super(scene, opts);
  }

  enable() {
    if (this.buttonEnabled) return;

    super.enable();
    this.alpha = 1;
    this.clearTint();
  }

  disable() {
    if (!this.buttonEnabled) return;

    super.disable();
    this.alpha = 1;
    this.tint = 0x888888;
  }

  _getAccessibilityHitarea() {
    const mat = this.getWorldTransformMatrix();
    if (!this._opts.hitEntity) {
      return {
        x: mat.getX(0, 0) - this.displayWidth * this.originX,
        y: mat.getY(0, 0) - this.displayHeight * this.originY,
        width: this.displayWidth,
        height: this.displayHeight,
      };
    } else {
      return {
        x:
          mat.getX(0, 0) -
          this._opts.hitEntity.x +
          this.displayWidth / 2 -
          this._opts.hitEntity.displayWidth / 2,
        y: mat.getY(0, 0) - this._opts.hitEntity.y - this._opts.hitEntity.displayHeight / 2,
        width: this._opts.hitEntity.displayWidth,
        height: this._opts.hitEntity.displayHeight,
      };
    }
  }

  enableInteractive() {
    if (!this._opts.hitEntity) {
      this.setInteractive({ useHandCursor: true });
    } else {
      this.setInteractive({
        useHandCursor: true,
        hitArea: new Phaser.Geom.Rectangle(
          this._opts.hitEntity.x + this.displayWidth / 2 - this._opts.hitEntity.displayWidth / 2,
          this._opts.hitEntity.y - this._opts.hitEntity.displayHeight / 2,
          this._opts.hitEntity.displayWidth,
          this._opts.hitEntity.displayHeight
        ),
        hitAreaCallback: Phaser.Geom.Rectangle.Contains,
      });
    }
  }
}
